// extracted by mini-css-extract-plugin
export default {"servicesCont":"services_servicesCont__8Odeg","cardsContainer":"services_cardsContainer__OrrDL"};